const rankings = [
  {
    rank: 1,
    title: '斗罗大陆',
    type: '国漫 · 玄幻',
    update: '每周六更新',
    desc: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20poster%20featuring%20martial%20arts%20fantasy%20character%20with%20blue%20and%20gold%20magical%20elements%20epic%20composition%20warm%20cinematic%20lighting%20clean%20background%20professional%20illustration&width=400&height=560&seq=ranking-card-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '咒术回战',
    type: '日漫 · 战斗',
    update: '每周四更新',
    desc: '高中生虎杖悠仁吞下诅咒之王的手指后，踏入了以诅咒对抗诅咒的咒术师世界。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20poster%20with%20dark%20action%20character%20in%20dynamic%20combat%20pose%20red%20and%20black%20color%20palette%20intense%20cinematic%20lighting%20clean%20background%20professional%20illustration&width=400&height=560&seq=ranking-card-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '我独自升级',
    type: '韩漫 · 奇幻',
    update: '每周三更新',
    desc: '被称为人类最弱兵器的程肖宇，在濒死之际获得了神秘的能力升级系统，踏上变强之路。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20poster%20with%20dark%20fantasy%20hunter%20character%20in%20cool%20pose%20purple%20and%20dark%20blue%20color%20palette%20dramatic%20lighting%20clean%20background%20professional%20illustration&width=400&height=560&seq=ranking-card-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '完美世界',
    type: '国漫 · 仙侠',
    update: '每周五更新',
    desc: '石昊为寻回失去的至尊骨，踏上了一条逆天而行的修炼之路，于乱世中一步步走向巅峰。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20poster%20with%20xianxia%20hero%20in%20flowing%20robes%20standing%20on%20mountain%20peak%20golden%20and%20white%20color%20palette%20ethereal%20lighting%20clean%20background%20professional%20illustration&width=400&height=560&seq=ranking-card-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '葬送的芙莉莲',
    type: '日漫 · 奇幻',
    update: '每周五更新',
    desc: '勇者一行击败魔王后，长寿的精灵魔法使芙莉莲踏上了重新理解人类情感的旅程。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20poster%20with%20elf%20mage%20character%20in%20peaceful%20meadow%20warm%20ivory%20and%20green%20color%20palette%20soft%20natural%20lighting%20clean%20background%20professional%20illustration&width=400&height=560&seq=ranking-card-05&orientation=portrait',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          人气排行
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="bg-background-100/80 rounded-xl overflow-hidden hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-[2/3] bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.title} - ${item.type}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3 w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">
                  {item.rank}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                </div>
                <p className="text-xs text-secondary-600 mb-2">{item.type}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <p className="text-xs text-accent-500 mt-2 font-medium">{item.update}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}